var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHearth = function SvgHearth(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15186 0.53125C3.17759 0.53125 0.717285 3.06386 0.717285 6.22559C0.717324 7.79899 1.32085 9.25831 2.38818 10.3301L2.396 10.3389L10.6479 18.998L10.8706 19.2305L11.0923 18.998L19.4995 10.1777C20.4813 9.11028 21.0229 7.70785 21.0229 6.22559C21.0229 3.06398 18.5635 0.531452 15.5894 0.53125C13.8849 0.53125 12.315 1.35823 11.2974 2.73242L10.8706 3.30859L10.4438 2.73242C9.4263 1.3583 7.85621 0.531359 6.15186 0.53125Z",
    fill: "white",
    stroke: "#5FB4BE",
    strokeWidth: 1.06221
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHearth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hearth.5fed9ab0.svg";
export { ForwardRef as ReactComponent };